// 一客多人混入文件
export default {
  data() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    return {
      userInfo:userInfo,
      staffForm: {
        guids: [],
        staffGuid: [],
        userGuid: '',
        staffName: ''
      },
    }
  },
  methods: {
    //提交分配
    submitFormStaff(customerType) {
      if (Array.isArray(this.staffForm.staffGuid) && !this.staffForm.staffGuid.length) {
        this.$message.error('请选择人员！')
        return
      }
      if (Array.isArray(this.staffForm.staffGuid) && this.staffForm.staffGuid.length > 10) {
        this.$NewMessage.warning({message: '您已超限, 最多指派10人'})
        return
      }
      let param = {
        operateStaffGuid: this.userInfo.staffGuid,
        guids : this.multipleSelection,
        belongStaffs : this.staffForm.staffGuid
      }
      this.fullscreenLoading = true;
      this.api.put(`/${serverConfig.msCustomerService}/common/adjust-staff?customerType=${customerType}`, param).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('分配成功');
          this.dialogCustomer = false;
          this.fullscreenLoading = false;
          this.organisationNames = '';
          this.staffForm.staffGuid = [];
          this.staffForm.guids = [];
          this.multipleSelection = [];
          this.$refs.multipleTable.clearSelection();
          this.getData(false);
        } else {
          this.fullscreenLoading = false;
          this.$message.error(res.data.msg);
        }
      }).catch(() => {
        this.fullscreenLoading = false;
      })
    },
    //获取人员下拉
    getStaff() {
      this.api
        .get(
          `/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=${this.page.tenantGuid}`
        )
        .then((res) => {
          if (res.data.msg == "success") {
            this.staffList = res.data.data;
            this.staffList.forEach(item=>{
              item.staffGuid = item.guid
            })
          }
        });
    },
  },
}